import { Component, TemplateRef } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
// import { DocumentTypeOptions, InvoiceInterface } from '@app/interface/invoice';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChangeDetectorRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CorrispettiviReceiptsApi } from '@app/services/corrispettivi-receipts-api.service';
import { OnInit } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SelectionModel } from '@angular/cdk/collections';
import { CorrispettiviReceiptsInterface } from '@app/interface/corrispettivi-receipts';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { MatSelectChange } from '@angular/material/select';
import { Organizations } from '@app/interface/organizations';
import { OrganizationApi } from '@app/services/organization-api.service';
import { InvoiceApi } from '@app/services/invoice-api';

@Component({
  selector: 'izy-corrispettivi-receipts',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSelectModule,
    MatPaginatorModule,
    MatCardModule,
    MatCheckboxModule,
    MatSortModule,
    MatIconModule,
    MatMenuModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    DatePipe,
    BackHeaderComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatChipsModule,
  ],
  standalone: true,
  templateUrl: './corrispettivi-receipts.component.html',
  styleUrl: './corrispettivi-receipts.component.scss',
})
export class CorrispettiviReceiptsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('amountInfoDialog') amountInfoDialog!: TemplateRef<any>;

  private _liveAnnouncer = inject(LiveAnnouncer);
  // private cdr = inject(ChangeDetectorRef);

  // Data & State
  dataSource = new MatTableDataSource<CorrispettiviReceiptsInterface>([]);
  selection = new SelectionModel<CorrispettiviReceiptsInterface>(true, []);
  isLoading = true;
  currentYear = new Date().getFullYear();
  // year filter
  years: number[] = [];
  selectedYear: number = this.currentYear;

  filteredCorrispettivi: CorrispettiviReceiptsInterface[] = []; // For mobile cards

  organization_data: Organizations | null = null;

  totalAmountThisYear: number = 0;
  totalAmountCreditThisYear: number = 0;

  // Totals for the Dashboard
  totalAmount: number = 0;
  totalVat: number = 0;
  totalDocs: number = 0;

  filterPanelOpenState = false;

  displayedColumns: string[] = [
    'selectAll',
    'Actions',
    'detection_date', // Data Rilevazione
    'transmission_date', // Data Invio
    'progressive_number',
    'device_id', // Matricola RT
    'n_docs', // Numero Scontrini
    'amount', // Totale Lordo
    'paid_cash', // Contanti
    'paid_electronic', // Elettronico
  ];

  // Filters object matching the CorrispettivoReceipt structure
  filters: any = {
    amount_gte: null,
    amount_lte: null,
    transmission_date_after: null,
    transmission_date_before: null,
    detection_date_after: null,
    detection_date_before: null,
    device_id_icontains: null,
  };

  private _emissionDateAfter: Date | null = null;

  get emissionDateAfter(): Date | null {
    return this._emissionDateAfter;
  }

  formatDateForBackend(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  set emissionDateAfter(value: Date | null) {
    this._emissionDateAfter = value;
    this.filters.transmission_date_after = value
      ? this.formatDateForBackend(value)
      : null;
  }

  constructor(
    private snackBar: MatSnackBar,
    private Corrispettiviservice: CorrispettiviReceiptsApi,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    public organizationService: OrganizationApi,
    private invoiceService: InvoiceApi,
  ) {}

  ngOnInit() {
    this.generateYears();
    this.getOrganization();
    this.loadCorrispettivi();

    this.cdr.detectChanges();
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;

      // Set default sorting by progressive_number descending (most recent first)
      this.sort.sort({
        id: 'progressive_number',
        start: 'desc',
        disableClear: false,
      });
    }

    this.dataSource.paginator = this.paginator;

    this.paginator._intl.itemsPerPageLabel = 'Elementi per pagina:';
    this.paginator._intl.nextPageLabel = 'Pagina successiva';
    this.paginator._intl.previousPageLabel = 'Pagina precedente';
    this.paginator._intl.firstPageLabel = 'Prima pagina';
    this.paginator._intl.lastPageLabel = 'Ultima pagina';

    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };

    this.cdr.detectChanges();
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // You can change this start year
    const endYear = currentYear + 2; // You can change this end year

    for (let year = startYear; year <= endYear; year++) {
      this.years.push(year);
    }

    // Optionally set default selection
    this.selectedYear = currentYear;
  }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const filterParams = {
      organization_id: organization_id,
    };

    this.organizationService
      .getOrganization<Organizations>(organization_id, filterParams)
      .subscribe({
        next: (organization_data: Organizations) => {
          // console.log('Organization:', organization_data);
          this.organization_data = organization_data; // Store the organization data

          // Apply theme based on organization source
          // this.applyOrganizationTheme(this.organization_data.source);

          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading organization:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.cdr.detectChanges();
        },
        // Remove complete() if you're handling everything in next/error
      });
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
  }

  loadCorrispettivi() {
    this.isLoading = true;
    const orgId = Number(this.route.snapshot.paramMap.get('organizationId'));

    // filters
    const params = {
      ...this.filters,
      organization_id: orgId,
      transmission_date__year: this.selectedYear,
      is_deleted: false,
    };

    if (this.filters.amount_gt) params.amount__gt = this.filters.amount_gt;
    if (this.filters.amount_lt) params.amount__lt = this.filters.amount_lt;

    if (this.filters.device_id_icontains)
      params.device_id__icontains = this.filters.device_id_icontains;

    // date filters
    if (this.filters.transmission_date_after)
      params.transmission_date__gte = this.formatDate(
        this.filters.transmission_date_after,
      );
    if (this.filters.transmission_date_before)
      params.transmission_date__lte = this.formatDate(
        this.filters.transmission_date_before,
      );

    params.ordering = '-progressive_number';

    console.log('params', params);

    this.Corrispettiviservice.getAllCorrispettiviReceipts(
      orgId,
      params,
    ).subscribe({
      next: (response: any) => {
        Promise.resolve().then(() => {
          // Extract the array from the paginated wrapper
          this.dataSource.data = response.results || [];
          if (this.paginator) this.paginator.firstPage();

          this.filteredCorrispettivi = [...response.results]; // Initialize mobile view data

          this.calculateTotalAmountThisYear(this.dataSource.data);

          this.isLoading = false;
          this.cdr.detectChanges();
        });
      },
      error: () => (this.isLoading = false),
    });

    this.cdr.detectChanges();
  }

  private calculateTotalAmountThisYear(
    corrispettiviReceipts: CorrispettiviReceiptsInterface[],
  ): void {
    // Initialize totals
    let totalAmountThisYear = 0;
    // let totalAmountCreditThisYear = 0;

    corrispettiviReceipts.forEach((corrispettivo) => {
      // Check if corrispettiviReceipts is from current year
      if (!corrispettivo.transmission_date) return;

      const corrispettivoYear = new Date(
        corrispettivo.transmission_date,
      ).getFullYear();
      if (corrispettivoYear !== this.selectedYear) return;

      let corrispettivoAmount: number;

      // Calculate amount
      corrispettivoAmount = Number(corrispettivo.amount) || 0;

      totalAmountThisYear += corrispettivoAmount;
    });

    // Set the properties
    this.totalAmountThisYear = totalAmountThisYear;
    console.log('Total amount:', this.totalAmountThisYear);
    // this.totalAmountCreditThisYear = totalAmountCreditThisYear;
  }

  onYearSelected(event: MatSelectChange): void {
    this.loadCorrispettivi();
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  isSomeSelected(): boolean {
    return this.selection.selected.length > 0 && !this.isAllSelected();
  }

  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
    }
  }

  clearSelection(): void {
    this.selection.clear();
  }

  getActiveFilterCount(): number {
    return Object.values(this.filters).filter(
      (val) => val !== null && val !== '',
    ).length;
  }

  resetFilters() {
    this.filters = {
      amount_gt: null,
      amount_lt: null,
      emission_date_after: null,
      emission_date_before: null,
      payment_date_after: null,
      payment_date_before: null,
      status: null,
      company_name_icontains: null,
    };
    this.loadCorrispettivi();
  }

  onRowClick(corrispettivo: CorrispettiviReceiptsInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([
      `/${org_id}/corrispettivi-receipts-detail`,
      corrispettivo.id,
    ]);
  }

  handleAmountInfoClick(event: Event): void {
    // These two lines prevent the click from bubbling up and triggering anything else
    event.preventDefault();
    event.stopPropagation();

    // Open the simple info dialog
    this.dialog.open(this.amountInfoDialog, {
      width: '90%',
      maxWidth: '450px',
      autoFocus: false,
    });
  }

  formatTableAmount(amount: number, currency: string = 'EUR'): string {
    const formatted = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

    return formatted;
  }

  showDelay = new FormControl(500);
  hideDelay = new FormControl(1000);

  // Riepilogo mostrato in tooltip al passaggio del mouse sulla riga.
  // Qui tutti i dati arrivano già con la lista (nessuna chiamata extra): il
  // tooltip serve a mostrare i campi che non stanno in tabella (dispositivo,
  // imponibile, IVA, sconti, venditore) più qualche valore derivato
  // (scontrino medio, ripartizione contanti/elettronico).
  getRowTooltip(receipt: CorrispettiviReceiptsInterface): string {
    const lines: string[] = [];

    lines.push(`Chiusura RT ${receipt.device_id || 'n.d.'}`);
    lines.push(
      [
        `Progressivo N. ${receipt.progressive_number}`,
        receipt.device_type || null,
        receipt.format || null,
      ]
        .filter(Boolean)
        .join(' · '),
    );
    lines.push(
      `Rilevato il ${this.formatTooltipDate(
        receipt.detection_date,
      )} · Trasmesso il ${this.formatTooltipDate(receipt.transmission_date)}`,
    );

    lines.push('──────────');

    const averageDoc = receipt.n_docs
      ? this.formatTableAmount(receipt.amount / receipt.n_docs)
      : null;
    lines.push(
      `Documenti emessi: ${receipt.n_docs ?? 0}${
        averageDoc ? ` (media ${averageDoc})` : ''
      }`,
    );
    lines.push(`Imponibile: ${this.formatTableAmount(receipt.partial_amount)}`);
    lines.push(
      `IVA${
        receipt.vat_percentage ? ` (${receipt.vat_percentage}%)` : ''
      }: ${this.formatTableAmount(receipt.vat_amount)}${
        receipt.vat_nature ? ` · natura ${receipt.vat_nature}` : ''
      }`,
    );
    if (receipt.discount) {
      lines.push(`Sconti/abbuoni: ${this.formatTableAmount(receipt.discount)}`);
    }
    lines.push(`Totale lordo: ${this.formatTableAmount(receipt.amount)}`);

    lines.push('──────────');

    lines.push(
      `Contanti: ${this.formatTableAmount(
        receipt.paid_cash,
      )}${this.formatTooltipShare(receipt.paid_cash, receipt.amount)}`,
    );
    lines.push(
      `Elettronico: ${this.formatTableAmount(
        receipt.paid_electronic,
      )}${this.formatTooltipShare(receipt.paid_electronic, receipt.amount)}`,
    );

    const seller = [
      receipt.vat_number_seller ? `P.IVA ${receipt.vat_number_seller}` : null,
      receipt.c_f_seller ? `C.F. ${receipt.c_f_seller}` : null,
    ]
      .filter(Boolean)
      .join(' · ');
    if (seller) {
      lines.push('──────────');
      lines.push(`Esercente: ${seller}`);
    }

    return lines.join('\n');
  }

  private formatTooltipDate(date: string | null | undefined): string {
    if (!date) return 'n.d.';
    const parsed = new Date(date);
    return isNaN(parsed.getTime())
      ? 'n.d.'
      : parsed.toLocaleDateString('it-IT');
  }

  private formatTooltipShare(value: number, total: number): string {
    if (!total || !value) return '';
    return ` (${Math.round((value / total) * 100)}%)`;
  }

  navigateToUploadXML() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/upload_corrispettivi_xml`]);
  }

  invoicingSummaryDownloadPdf(): void {
    // if (this.dataSource.filteredData.length === 0) {
    //   this.showErrorMessage('Seleziona almeno una fattura.');
    //   return;
    // }

    // Extract the IDs
    const invoiceIds = Array.from({ length: 10000 }, (_, index) => index + 1); // FIXME: not best way to do this

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.snackBar.open('Generazione del report PDF in corso...', 'Chiudi', {
      duration: 2000,
    });

    // 2. Call the new service method
    this.invoiceService
      .downloadInvoicingSummaryPdf(
        organization_id,
        invoiceIds,
        this.selectedYear,
      )
      .subscribe({
        next: (blob: Blob) => {
          const blobUrl = window.URL.createObjectURL(blob);

          // 2. Create a hidden link and click it
          const link = document.createElement('a');
          link.href = blobUrl;

          // You can set a default name or attempt to parse headers if you use
          // observe: 'response' in the HttpClient call above
          link.download = `Situazione_Contabile_${this.organization_data?.name}_${this.selectedYear}.pdf`;

          document.body.appendChild(link);
          link.click();

          // 3. Cleanup
          document.body.removeChild(link);
          setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);

          // 4. Clean up UI state
          this.isLoading = false;
          this.showSuccessMessage(`Download del report completato.`);
          this.clearSelection();
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error downloading ZIP:', error);
          this.isLoading = false;
          this.snackBar.open(
            'Errore durante il download del report.',
            'Chiudi',
            {
              duration: 3000,
            },
          );
          this.cdr.detectChanges();
        },
      });
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
